import { ID } from 'domain/bubble';
import * as PIXI from 'pixi.js';
import { Sprite } from 'pixi.js';

export type CachedSprites = Sprite[];

const debounce = () =>
  new Promise((res) => {
    setTimeout(() => res(true), 4);
  });

export async function fetchImage(id: ID, source?: string) {
  if (!source) {
    return { [id]: null };
  }
  const texture = PIXI.Sprite.from(source);
  const img = new PIXI.ImageResource(source);
  await img.load();
  // If dont use min debounse image can accept 1px as w/h size
  await debounce();
  if (img.width !== texture.width) {
    console.log('Debuglog images sizes', img.width, texture.width);
  }
  return { [id]: texture };
}
